module.exports = __webpack_public_path__ + "static/media/correct-1.5ce71312.mp3";